<template>
  <!-- The way back to the getting started from the full dashboard, at the bottom of the sidebar: a ring with « 3/9 » inside
       and, when the bar is expanded, the name and the next step. A separate block rather than a decoration on a nav entry:
       the entries' icons are already circles, a ring around one made two. In the guided mode the home is the getting
       started itself, so the block stays away; it goes for good once getting started is finished. -->
  <NuxtLink v-if="visible" to="/onboarding" class="nav-card" :class="{ 'nav-card--current': $route.path === '/onboarding' }"
            :aria-label="t('onboarding.navCard.label', { done: status.done, total: status.total })">
    <span class="nav-card__ring">
      <svg viewBox="0 0 36 36" aria-hidden="true">
        <circle class="nav-card__track" cx="18" cy="18" r="15.5" />
        <circle class="nav-card__arc" cx="18" cy="18" r="15.5" pathLength="100" :stroke-dasharray="`${ percent } 100`" />
      </svg>
      <span class="nav-card__count">{{ status.done }}/{{ status.total }}</span>
    </span>
    <span class="nav-card__label">
      <strong class="nav-card__title">{{ t("onboarding.navCard.title") }}</strong>
      <span class="nav-card__next">{{ next ? t(`onboarding.steps.${ next.key }.title`) : "" }}</span>
    </span>
  </NuxtLink>
</template>

<script setup>
import "~/assets/scss/components/nav-card.scss";

// Same state as the getting-started page (shared): the ring moves forward when a step gets checked, without an extra read.
const { t } = useI18n();
const { status, next, finished, loaded, failed, mode } = useSetupMode();

const visible = computed(() => loaded.value && !failed.value && !finished.value && mode.value === "full");
const percent = computed(() => (status.value.total ? Math.round((status.value.done / status.value.total) * 100) : 0));
</script>
